// Main scripts file for Hoan My Theme
// Import modules
import "./modules/Main.js";

// Initialize when DOM is ready
// document.addEventListener("DOMContentLoaded", function () {
//   // console.log("Hoan My Theme loaded successfully!");
// });
